/** @module Specification/DataPackageReset */
define([
	"dojo/_base/declare",
	"csi/action/Controller"
], function(declare,Controller) {

	return declare(Controller, {

		/**
		 * @override
		 *
		 * Refresh views under DataPackage
		 */
		postProcessSuccess: function() {
			// summary: if RefreshDataSheets was true, then refresh data sheets view as well as properties as file may have been reset
			var	viewParent = this.widget.viewParent;
			var view = viewParent.getChildView("Properties");
			if (view) {
				view.refreshWidget(true);
			}
			view = viewParent.getChildView("DataSheets") || viewParent.getChildView("DataSheetsInAssortment") || viewParent.getChildView("SKUDataSheets");
			if (view) {
				view.refreshWidget(true);
			}
			view = viewParent.getChildView("Documents");
			if (view) {
				view.refreshWidget(true);
			}
		}
	});
});